// Internal modules
import { getGlobals, getLocale } from '@/lib';
import type { GenericObjectType } from '@/types';

const cache: GenericObjectType = {};

const getOccupationList = () => getGlobals().content.occupationList;

const clearCache = (): void => {
  Object.keys(cache).forEach(key => {
    delete cache[key];
  });
};

const getMemoOccupationSelections = (): {
  key: string;
  text: string;
  value: string;
}[] => {
  const key = getLocale().locale;
  if (cache[key]) {
    return cache[key];
  }
  const occupations: GenericObjectType<string> = getOccupationList();
  const occupationSelections = Object.entries(occupations).map(
    ([propName, text]) => ({
      key: propName,
      text,
      value: propName,
    }),
  );
  cache[key] = occupationSelections;
  return occupationSelections;
};

export { getMemoOccupationSelections, clearCache };
